var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.showUnauthorizedModal, width: "380", persistent: "" }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", [_vm._v("Log In")]),
          _vm._v(" "),
          _c("v-card-text", [
            _vm._v(
              "\n      You are unauthorized to see this page. Please sign up!\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                { attrs: { color: "accent" }, on: { click: function() {} } },
                [_vm._v("Sign Up")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { color: "accent" }, on: { click: _vm.back } },
                [_vm._v("Back")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e4af4ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4af4ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UnauthorizedModal.vue
// module id = null
// module chunks = 